import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.js";
import "./index.css"; // Import global styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Provider } from 'react-redux'
import { BookmarkedProvider } from "./Context/BookmarkedContext.jsx";


const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2", // default blue
    },
    secondary: {
      main: "#f50057",
    },
  },
});



const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
  <BrowserRouter>
 <BookmarkedProvider>
       <ThemeProvider theme={theme}>
        <App />
     <ToastContainer/>
    </ThemeProvider>
 </BookmarkedProvider>


  
   
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

